/* this file is For providing header Componet */
import React from 'react';
function Header(props){

return  (
    <header>
      <h1>Xmeme</h1>
    </header>
  );
}

export default Header;